import React from 'react';

import AdminUpgradePlanContainer from 'admin/components/AdminUpgradePlan/AdminUpgradePlanContainer';
import AdminUpgradePlanStripeContainer from 'admin/components/AdminUpgradePlan/AdminUpgradePlanStripeContainer';

import GTMScript from 'components/GTMScript';

type Props = {
  orgUuid?: string;
  isSimpleForm: boolean;
};

export default function AdminUpgradePlanView(props: Props) {
  const { orgUuid, isSimpleForm } = props;

  return (
    <React.Fragment>
      <GTMScript />
      <AdminUpgradePlanStripeContainer>
        <AdminUpgradePlanContainer orgUuid={orgUuid} isSimpleForm={isSimpleForm} />
      </AdminUpgradePlanStripeContainer>
    </React.Fragment>
  );
}
